import { useTranslation } from 'react-i18next';

interface Props {
  correct: number;
  wrong: number;
  xpEarned: number;
  streak: number;
  onClose: () => void;
}

export default function SessionSummary({ correct, wrong, xpEarned, streak, onClose }: Props) {
  const { t } = useTranslation();
  const total = correct + wrong;
  const accuracy = total > 0 ? Math.round((correct / total) * 100) : 0;

  return (
    <div className="text-center space-y-6">
      <div>
        <p className="text-4xl mb-2">📊</p>
        <h2 className="text-2xl font-bold text-gray-800">{t('learning.sessionComplete')}</h2>
        <p className="text-gray-500">{t('learning.goodJob')}</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-green-50 rounded-xl p-4">
          <p className="text-2xl font-bold text-green-600">{correct}</p>
          <p className="text-sm text-green-500">{t('learning.correct')}</p>
        </div>
        <div className="bg-red-50 rounded-xl p-4">
          <p className="text-2xl font-bold text-red-600">{wrong}</p>
          <p className="text-sm text-red-500">{t('learning.wrong')}</p>
        </div>
        <div className="bg-indigo-50 rounded-xl p-4">
          <p className="text-2xl font-bold text-indigo-600">+{xpEarned}</p>
          <p className="text-sm text-indigo-500">XP</p>
        </div>
        <div className="bg-amber-50 rounded-xl p-4">
          <p className="text-2xl font-bold text-amber-600">{accuracy}%</p>
          <p className="text-sm text-amber-500">{t('learning.accuracy')}</p>
        </div>
      </div>

      {streak > 1 && (
        <div className="bg-orange-50 rounded-xl p-3">
          <p className="text-lg">🔥 {t('learning.consecutiveDays', { count: streak })}</p>
        </div>
      )}

      <button
        onClick={onClose}
        className="w-full py-4 bg-indigo-600 text-white font-bold rounded-xl text-lg hover:bg-indigo-700 transition"
      >
        {t('learning.goHome')}
      </button>
    </div>
  );
}
